import { styled } from "@mui/material";

export const MenuContainer = styled("div")({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '2rem',
});